<template>

    <div class="box-typical-body panel-body" style="overflow: hidden">
        <ul class="nav nav-tabs justify-content-center">
            <li v-for="type in types" :key="type" class="nav-item">
                <a  v-on:click="() => eventType = type"
                    :class='["nav-link", eventType == type ? "active" : ""]'
                    href="javascript:void(0)">{{ type }}</a>
            </li>
        </ul>
        <!-- <div v-if="loading" style=""> -->
        <!--     <vue-spinner style="margin: 10% 50%;"></vue-spinner> -->
        <!-- </div> -->
        <!-- <div v-else-if="_.isEmpty(reportData)" :class="['alert', 'alert-info', 'm-0']"> -->
        <!--     {{ 'No results' }} -->
        <!-- </div> -->
        <div class="mt-3">
            <table-component
                v-if="initialized"
                :content="content"
                :timestamp="timestamp"
                :selected="selected"
                :config="config"
                :query="query"

                :updateBatch="doNothing"
                :addNotification="doNothing"
                :changeQuery="changeQuery"
                :changeUrl="doNothing"
                :onInitialized="doNothing"
                :onSelected="doNothing"
                ></table-component>
            <template v-if="eventType == 'click' && !_.isEmpty(urlReport.items)">
                <hr>
                <h4>Summary of URLs clicked</h4>
                <b-table striped hover bordered
                    :fields="urlReport.fields"
                    :items="urlReport.items"></b-table>
            </template>
        </div>
    </div>
</template>
<script charset="utf-8">
import M from 'moment';
import Vuex from 'vuex';
import VueSpinner from 'vue-spinner/src/MoonLoader.vue';
import TableComponent from '72cms-ui/components/TableComponent';

export default {
    data() {
        const types = [
            // 'processed',
            // 'delivered',
            'open',
            // 'unique_open',
            'click',
            // 'unique_click',
            // 'deferred',
            'bounce',
            // 'dropped',
            // 'unsubscribe',
            // 'spamreport',
        ];

        return {
            initialized: false,
            messages: [],
            eventType: 'open',
            types,
            selectedTypes: [
                ...types
            ],
        }
    },

    props: [
        'campaign', 'dateRange', 'api',
    ],

    components: {
        VueSpinner,
        TableComponent,
    },

    created() {
        this.changePath(`/campaign/${_.get(this.campaign, 'id')}/message_statuses`)
        this.changeQuery({
            filter: `status:${this.eventType};updated_at:$range(${this.getDateRangeFilter()})`,
        });
    },

    watch: {
        dateRange() {
            this.getData({
                query: {
                    filter: `status:${this.eventType};updated_at:$range(${this.getDateRangeFilter()})`,
                    ['aggregate[$count]']: 'url',
                    ['aggregate[$total]']: _.get(this.campaign, 'id'),
                }
            });
        },

        query() {
            this.getData({
                query: {
                    filter: `status:${this.eventType};updated_at:$range(${this.getDateRangeFilter()})`,
                    ['aggregate[$count]']: 'url',
                    ['aggregate[$total]']: _.get(this.campaign, 'id'),
                }
            }).then(() => this.initialized = true);
        },

        eventType(newVal) {
            this.changeQuery({
                filter: `status:${newVal}`,
            })
        },
    },

    computed: {
        ...Vuex.mapGetters('sub', {
            content: 'content',
            query: 'query',
            path: 'path',
            selected: 'selected',
            timestamp: 'timestamp',
            loading: 'loading',
        }),

        type() {
            return _.get(this.content, 'type');
        },

        apiPath() {
            return _.get(this.config, 'apiPath', '');
        },

        config() {
            return {
                fields: {
                    email: {},
                    data: {
                        component: {
                            template: `<div>
                                <span v-if="initialValue.url" class="">
                                    <strong>URL</strong>: {{ initialValue.url }}
                                </span>
                                <span v-if="initialValue.reason" class="">
                                    <strong>Reason</strong>: {{ initialValue.reason }}
                                </span>
                            </div>`,
                            props: ['initialValue'],
                        }
                    },
                    updated_at: {},
                },
                pagination: true,
                searchable: true,
            }
        },

        fields() {
            return {
                email: {
                    label: 'Email',
                    value: (val, data) => {
                        return `<span class="" style="white-space: nowrap;">${val || 0}</span>`;
                    },
                },
                data: {
                    label: 'Data',
                    value: (val, data) => {
                        let result = [];
                        if (val.ip) {
                            result.push(``);
                        }
                        if (val.url) {
                            result.push(`<span class=""><strong>URL</strong>: ${val.url}</span>`);
                        }
                        if (val.reason) {
                            result.push(`<span class=""><strong>Reason</strong>: ${val.reason}</span>`);
                        }

                        return _.join(result, '<br>');
                    },
                },
                updated_at: {
                    label: 'Date',
                    value: (val, data, __) => `<p class="small" style="white-space: nowrap;">${val}</p>`,
                },
            };
        },
        reportData() {
            return _.chain(this.messages)
                .map(item => {
                    return {
                        id: item.id, type: item.type,
                        ...(item.attributes),
                        ...(item.meta),
                    }
                })
                .filter(item => {
                    let betweenDateRange = (item.updated_at >= this.dateRange[0])
                        && (item.updated_at <= this.dateRange[1])
                    return betweenDateRange;
                })
                .value();
        },

        reportDataHtml() {
            return _.chain(this.reportData)
                .map(this.formatItemData)
                .value();
        },

        urlReport() {
            return {
                items: this.getUrlReport(),
                fields: [
                    { key: 'url', label: 'URL' },
                    { key: 'count', sortable: true },
                    { key: 'percent', sortable: true },
                ]
            };
        },
    },

    methods: {
        ...Vuex.mapActions('sub', {
            getInitialData: 'getInitialData',
            getData: 'getData',
            setSelected: 'setSelected',
            importSelected: 'importSelected',

            setPath: 'setPath',
            changePath: 'changePath',
            changeQuery: 'changeQuery',
            changePath: 'changePath',
        }),

        formatItemData(attributes) {
            const keys = _.keys(this.fields);
            const simplyReturn = (val) => val;
            const id = _.get(attributes, 'id');

            return _.chain(attributes)
                .toPairs()
                .reduce((tmp, [key, rawValue]) => {
                    if (keys.indexOf(key) < 0) {
                        return tmp;
                    }

                    const handler = _.get(this.fields, [key, 'value'], simplyReturn);
                    return { ...tmp, id, [key]: handler(rawValue, attributes, this.__, this._) }
                }, {})
                .value();
        },

        gotoItem(id) {
            if (!id) return;
            window.location.href = `#/message/${id}`;
        },

        getUrlReport() {
            let total = _.chain(this.content)
                .get('meta.$count.url', {})
                .values()
                .sum()
                .value();

            return _.chain(this.content)
                .get('meta.$count.url', {})
                .toPairs()
                .map(pairs => {
                    return {
                        url: pairs[0],
                        count: pairs[1],
                        percent: Math.round(pairs[1] * 10000 / total) / 100 + '%',
                    }
                })
                .sortBy('count')
                .value();
        },

        getDateRangeFilter() {
            let dateRange = this.dateRange;

            return _.join([
                dateRange[0],
                M(dateRange[1]).add(1, 'day').format('YYYY-MM-DD'),
            ]);
        },

        doNothing() {

        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/cms/js/components/report/MessageTableComponent.vue